var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Funcionario Loteador" } },
          [
            _c(
              "b-input-group",
              { staticClass: "input-group-merge" },
              [
                _c(
                  "b-input-group-prepend",
                  { attrs: { "is-text": "" } },
                  [_c("feather-icon", { attrs: { icon: "UserIcon" } })],
                  1
                ),
                _c("b-form-input", {
                  attrs: { readonly: "", placeholder: "Funcionario Loteador" },
                  model: {
                    value: _vm.currentUser.nombre,
                    callback: function($$v) {
                      _vm.$set(_vm.currentUser, "nombre", $$v)
                    },
                    expression: "currentUser.nombre"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }